import { LANGS } from "./resolveLang";

const SITE_ORIGIN = "https://brilliantflux.agency";

export function siteUrl(lang) {
  const code = LANGS.includes(lang) ? lang : "en";
  return `${SITE_ORIGIN}/${code}`;
}

// Event-type slugs are owned by the agency landing repository
// (brilliantflux.agency). This is a copy: a cross-repository import is
// impossible from this demo. Bulgarian maps to the Russian event on purpose —
// meeting-bg does not exist on cal.com (404) and the landing page makes the
// same choice; do not "fix" it into meeting-bg.
const BOOKING_EVENT = {
  en: "meeting-en",
  uk: "meeting-uk",
  ru: "meeting-ru",
  bg: "meeting-ru",
};

export function bookingUrl(lang) {
  const code = LANGS.includes(lang) ? lang : "en";
  return `https://cal.com/brilliantflux/${BOOKING_EVENT[code]}`;
}
